import APIcon from './APIcon.js';

export default APIcon;



// WEBPACK FOOTER //
// ./src/components/common/APIcon/index.js